import { range } from 'lodash'

export function clamp(v: number, min: number, max: number) {
  if (v < min) {
    return min
  }
  if (v > max) {
    return max
  }
  return v
}
